export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-torsos-29b88672b1e1388b4728d6478a7c8919.svg";